import { gql } from '@apollo/client';

export const ADD_DOCS_AND_FORMS_TO_MATTER = gql`
  mutation addDocsAndFormsToMatter(
    $matterId: MatterServiceUuid!
    $items: MatterServiceJsonb
  ) {
    items: matterServiceAddDocsAndFormsToMatter(
      args: { matterId: $matterId, items: $items }
    ) {
      id
    }
  }
`;

export const ADD_DOCS_AND_FORMS_TO_MATTER_FOLDER = gql`
  mutation addDocsAndFormsToMatterFolder(
    $matterId: MatterServiceUuid!
    $folderId: MatterServiceUuid!
    $items: MatterServiceJsonb
  ) {
    items: matterServiceAddDocsAndFormsToFolder(
      args: { matterId: $matterId, folderId: $folderId, items: $items }
    ) {
      id
    }
  }
`;

export const ADD_DOCS_AND_FORMS_TO_MATTER_NEW_FOLDER = gql`
  mutation addDocsAndFormsToMatterNewFolder(
    $matterId: MatterServiceUuid!
    $folderName: String!
    $items: MatterServiceJsonb
  ) {
    items: matterServiceCreateFolderAddDocsAndForms(
      args: { matterId: $matterId, folderName: $folderName, items: $items }
    ) {
      id
    }
  }
`;

export const REMOVE_FORMS_FROM_MATTER = gql`
  mutation removeFormsFromMatter($itemIds: [MatterServiceUuid!]!) {
    matterServiceDelete_matterDocsAndForms(where: { id: { _in: $itemIds } }) {
      returning {
        id
      }
    }
  }
`;
